module.exports = __webpack_public_path__ + "static/media/emptyporto.c00613a7.svg";